import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core'
import { AuthenticationService, User } from '../../../../../framework/authentication/services/authentication.service'
import { UserProfileService } from '../../../../../framework/authentication/services/user-profile.service'
import { UserProfile } from '../../../../../framework/authentication/models/UserProfile'
import { DealUserProfileComponent } from '../deal-user-profile/deal-user-profile.component'
import { UiStepperComponent } from '../../../../../ui/monolith/components/ui-stepper/ui-stepper.component'
import { IdentityService, OnfidoStatus } from '../../../services/identity.service'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
    selector: 'mg-deal-identity',
    templateUrl: './deal-identity.component.html',
    styleUrls: ['./deal-identity.component.scss'],
})
export class DealIdentityComponent implements OnInit {
    user: User
    userProfile: UserProfile
    isSavingUserProfile: boolean = false

    public onfidoStatus: OnfidoStatus

    forceCheck: boolean = false

    @ViewChild(DealUserProfileComponent)
    userProfileComponent: DealUserProfileComponent

    @ViewChild(UiStepperComponent)
    stepper: UiStepperComponent

    @Output()
    completed: EventEmitter<void> = new EventEmitter()

    constructor(
        private authenticationService: AuthenticationService,
        private userProfileService: UserProfileService,
        private identityService: IdentityService
    ) {}

    ngOnInit() {
        this.authenticationService.currentUser.pipe(untilDestroyed(this)).subscribe(user => {
            if (user) {
                this.user = user
                this.syncOnfidoStatus()
            }
        })
        this.userProfileService.userProfile.pipe(untilDestroyed(this)).subscribe(userProfile => {
            if (userProfile) {
                this.userProfile = userProfile
            }
        })
    }

    async syncOnfidoStatus() {
        this.onfidoStatus = await this.identityService.getStatus()
    }

    async onUserProfileSave() {
        if (this.userProfileComponent.valid && !this.isSavingUserProfile) {
            this.isSavingUserProfile = true
            await this.userProfileService.persistUserProfile()
            this.stepper.activeIndex = 1
            this.isSavingUserProfile = false
        }
    }

    onOnfidoComplete() {
        this.syncOnfidoStatus()
        this.completed.emit()
        this.stepper.activeIndex = 2
    }
}
